const MAX_FILESTACK_SIZE = 10000;

type Props = {
  originalWidth: number | undefined;
  originalHeight: number | undefined;
  requestedWidth?: number;
  requestedHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
};

export function getFilestackImageSize({
  originalWidth,
  originalHeight,
  requestedWidth,
  requestedHeight,
  maxWidth: maxWidthProp,
  maxHeight: maxHeightProp,
}: Props): {
  width: number | undefined;
  height: number | undefined;
} {
  if (requestedWidth || requestedHeight) {
    return { width: requestedWidth, height: requestedHeight };
  }

  if (!originalWidth || !originalHeight) {
    return { width: undefined, height: undefined };
  }

  const maxWidth = maxWidthProp
    ? Math.min(maxWidthProp, MAX_FILESTACK_SIZE)
    : MAX_FILESTACK_SIZE;

  const maxHeight = maxHeightProp
    ? Math.min(maxHeightProp, MAX_FILESTACK_SIZE)
    : MAX_FILESTACK_SIZE;

  const widthScaleDownFactor =
    originalWidth > maxWidth ? maxWidth / originalWidth : 1;

  const heightScaleDownFactor =
    originalHeight > maxHeight ? maxHeight / originalHeight : 1;

  const scaleDownFactor = Math.min(widthScaleDownFactor, heightScaleDownFactor);

  const width = Math.floor(originalWidth * scaleDownFactor);
  const height = Math.floor(originalHeight * scaleDownFactor);

  return { width, height };
}
